import React from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const HumidityGauge = ({ humidity }) => {
  const getHumidityColor = (value) => {
    if (value < 30) return "#4CAF50"; // Green for low humidity
    if (value < 60) return "#2196F3"; // Blue for moderate humidity
    if (value < 80) return "#FF9800"; // Orange for high humidity
    return "#F44336"; // Red for very high humidity
  };

  return (
    <div className="bg-white rounded-lg p-4">
      <div className="flex items-center justify-center">
        <div className="w-32 h-32">
          <CircularProgressbar
            value={humidity}
            text={`${humidity}%`}
            styles={buildStyles({
              pathColor: getHumidityColor(humidity),
              textColor: "#374151",
              trailColor: "#E5E7EB",
              textSize: "16px",
            })}
          />
        </div>
      </div>
      <div className="mt-4 text-center">
        <p className="text-sm text-gray-600">
          {humidity < 30
            ? "Low humidity - Dry conditions"
            : humidity < 60
            ? "Comfortable humidity level"
            : humidity < 80
            ? "High humidity - Muggy conditions"
            : "Very high humidity - Uncomfortable conditions"}
        </p>
      </div>
    </div>
  );
};

export default HumidityGauge;
